import store from '@/store'
import TimesheetsRouter from '@/components/pages/timesheet/index.vue';
import Timesheets from '@/components/pages/timesheet/Timesheets.vue';
import TimesheetDetail from '@/components/pages/timesheet/TimesheetDetail.vue';
import TimesheetBulkUpdate from '@/components/pages/timesheet/TimesheetBulkUpdate.vue';
import TimesheetWorkSummary from '@/components/pages/timesheet/TimesheetWorkSummary.vue';

export default {
  path: '/timesheets',
  name: 'TimesheetsRouter',
  component: TimesheetsRouter,
  children: [
    {
      path: '/timesheets',
      component: Timesheets,
      name: 'Timesheets',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/timesheets/bulkUpdate',
      component: TimesheetBulkUpdate,
      name: 'TimesheetBulkUpdate',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/timesheets/work-summary',
      component: TimesheetWorkSummary,
      name: 'TimesheetWorkSummary',
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: '/tutors/:tutorId/timesheets',
      component: TimesheetDetail,
      name: 'TimesheetDetail',
      meta: {
        acceptRoles: ['senior', 'tutor', 'admin'],
      },
      beforeEnter: ((to, from, next) => {
        if (store.state.auth?.profile?.authority !== 'tutor') {
          // 権限がtutor以外の場合OK
          next()
        } else if (to?.params?.tutorId === store.state.auth?.profile?.id) {
          // 権限がtutorかつ自身の勤怠の場合はOK
          next()
        } else {
          next({ name: 'Home' })
        }
      }),
    },
  ],
}
